import { render, staticRenderFns } from "./CompanyDetailsStep.vue?vue&type=template&id=3c501be6&scoped=true&"
import script from "./CompanyDetailsStep.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsStep.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsStep.vue?vue&type=style&index=0&id=3c501be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c501be6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCheckbox,VIcon})
